import { Base } from "./base";
import { Member } from "./member";

export enum OrganizationType {
    ElementarySchool = "E",
    MiddleSchool = "M",
    HighSchool = "H",
    University = "U",
    Etc = "ETC",
}
export interface OrgUserBase extends Member {
    orgId: string;
    org?: Organization;
}

export interface OrgUser extends OrgUserBase {
    phoneNumber: string;
    description?: string;
    role?: string;
    position?: string;
}

export interface Organization extends Base {
    uid: string;
    name: string;
    president: string;
    type: string;
    address?: {
        postCode?: string;
        address?: string;
        addressDetail?: string;
    };
    dept: string;
    deptPersonName: string;
    deptPersonPhoneNumber: string;
    email?: string;
    phoneNumber?: string;
    description?: string;
    admin?: OrgUserBase;
    status?: string;
}
